import { render, staticRenderFns } from "./SubmitButton.vue?vue&type=template&id=fa76e44a&scoped=true"
import script from "./SubmitButton.vue?vue&type=script&lang=js"
export * from "./SubmitButton.vue?vue&type=script&lang=js"
import style0 from "./SubmitButton.vue?vue&type=style&index=0&id=fa76e44a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa76e44a",
  null
  
)

export default component.exports